import axios from 'axios';

import { ViewAmostraAtual } from '@models/views/view-amostra-atual.model';
import { CriaAmostraPlacaDto } from '@/../../back/src/amostras-placas/dto/cria-amostra-placa.dto';
import { CriaAmostraPlacaSimplesDto } from '@/../../back/src/amostras-placas/dto/cria-amostra-placa-simples.dto';
import { SolicitaAnaliseAmostrasPlacasDto } from '@/../../back/src/amostras-placas/dto/solicita-analise-amostras-placa.dto';
import { EntraLabGruAmostrasPlacaDto } from '@/../../back/src/amostras-placas/dto/entra-lab-gru-amostras-placa.dto';
import { IniciaCalcinacaoAmostrasPlacaDto } from '@/../../back/src/amostras-placas/dto/inicia-calcinacao-amostras-placa.dto';
import { FinalizaCalcinacaoAmostrasPlacaDto } from '@/../../back/src/amostras-placas/dto/finaliza-calcinacao-amostras-placa.dto';
import { ListaAcompanhamentoAmostraPlacaQueryDto } from '@/../../back/src/amostras-placas/dto/lista-acompanhamento-amostra-placa-query-dto';
import { AmostraPlaca } from '@models/amostra-placa.model';

const busca = async (amostraPlacaId: number): Promise<AmostraPlaca> => {
  const res = await axios.get<AmostraPlaca>(
    `/amostras_placas/${amostraPlacaId}`,
  );
  return res.data;
};

const cria = async (
  criaAmostraPlacaDto: CriaAmostraPlacaDto,
): Promise<AmostraPlaca> => {
  const res = await axios.post<AmostraPlaca>(
    '/amostras_placas',
    criaAmostraPlacaDto,
  );
  return res.data;
};

const criaSimples = async (
  criaAmostraPlacaSimplesDto: CriaAmostraPlacaSimplesDto,
): Promise<AmostraPlaca> => {
  const res = await axios.post<AmostraPlaca>(
    '/amostras_placas/simples',
    criaAmostraPlacaSimplesDto,
  );
  return res.data;
};

const listaProducao = async (): Promise<ViewAmostraAtual[]> => {
  const res = await axios.get<ViewAmostraAtual[]>('/amostras_placas/producao');
  return res.data;
};
const listaAcompanhamento = async (
  queryDto: ListaAcompanhamentoAmostraPlacaQueryDto,
): Promise<{
  count: number;
  rows: ViewAmostraAtual[];
}> => {
  const res = await axios.get<{ count: number; rows: ViewAmostraAtual[] }>(
    '/amostras_placas/acompanhamento',
    {
      params: queryDto,
    },
  );
  return res.data;
};
const listaSolicitacaoAnalise = async (): Promise<ViewAmostraAtual[]> => {
  const res = await axios.get<ViewAmostraAtual[]>(
    '/amostras_placas/solicitacao_analise',
  );
  return res.data;
};
const listaLabGru = async (): Promise<ViewAmostraAtual[]> => {
  const res = await axios.get<ViewAmostraAtual[]>(
    '/amostras_placas/laboratorio_gru',
  );
  return res.data;
};

const realizaEntrada = async (
  formData: EntraLabGruAmostrasPlacaDto,
): Promise<AmostraPlaca[]> => {
  const res = await axios.post<AmostraPlaca[]>(
    '/amostras_placas/entrar_lab_gru',
    formData,
  );
  return res.data;
};

const solicitaAnalise = async (
  formData: SolicitaAnaliseAmostrasPlacasDto,
): Promise<AmostraPlaca[]> => {
  const res = await axios.post<AmostraPlaca[]>(
    '/amostras_placas/solicitar_analise',
    formData,
  );
  return res.data;
};

const iniciaCalcinacao = async (
  formData: IniciaCalcinacaoAmostrasPlacaDto,
): Promise<AmostraPlaca[]> => {
  const res = await axios.post<AmostraPlaca[]>(
    '/amostras_placas/calcinar_inicio',
    formData,
  );
  return res.data;
};

const finalizaCalcinacao = async (
  formData: FinalizaCalcinacaoAmostrasPlacaDto,
): Promise<AmostraPlaca[]> => {
  const res = await axios.post<AmostraPlaca[]>(
    '/amostras_placas/calcinar_fim',
    formData,
  );
  return res.data;
};

const remove = async (amostraPlacaId: number): Promise<AmostraPlaca> => {
  const response = await axios.delete<AmostraPlaca>(
    `/amostras_placas/${amostraPlacaId}`,
  );
  return response.data;
};

export default {
  busca,
  cria,
  criaSimples,
  listaProducao,
  listaAcompanhamento,
  listaSolicitacaoAnalise,
  listaLabGru,
  realizaEntrada,
  solicitaAnalise,
  iniciaCalcinacao,
  finalizaCalcinacao,
  remove,
};
